import React, { useState } from "react";
import "./ContactInput.css";

export default function ContactInput({ nextStep, updateFormData, postcode }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [house, setHouse] = useState("");
  const [consent, setConsent] = useState(true);

  const isEmailValid = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleContinue = () => {
    if (!name || !email || !phone || !house) {
      alert("Please complete all fields.");
      return;
    }
    if (!isEmailValid(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    updateFormData({
      name,
      email,
      phone,
      houseNumberOrName: house,
      contactConsent: consent,
    });

    nextStep();
  };

  return (
    <div className="contact-container">
      <div className="contact-card">
        <h2>Your contact details</h2>
        <p className="intro-para">
          We'll share your potential savings on screen next. We'll also share the full details by email for your records for you to use when comparing quotes and potential solutions.
        </p>

        <div className="input-group">
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Jane Smith"
          />
        </div>

        <div className="input-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="jane@example.com"
          />
        </div>

        <div className="input-group">
          <label>Phone</label>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="07123 456789"
          />
        </div>

        <div className="input-group">
          <label>House name or number</label>
          <input
            type="text"
            value={house}
            onChange={(e) => setHouse(e.target.value)}
            placeholder="e.g. 42 or Rose Cottage"
          />
        </div>

        <p className="postcode-display">Postcode: <strong>{postcode}</strong></p>

        <div className="consent-group">
          <label>
            <input
              type="checkbox"
              checked={consent}
              onChange={() => setConsent(!consent)}
            />
            <span>
              Please contact me to discuss optimised solar for my property.
              <em> Optify promises no hard sell and no spam, simply a courtesy call or email to help you decide if solar is right for you and share our expertise in helping homeowners maximise the savings from solar.</em>
            </span>
          </label>
        </div>

        <button className="continue-button" onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}
